import React from 'react'
import dayjs from 'dayjs'
import { Value } from '../../elements'

export const getMobileFields = () => [
  {
    key: 'date_work_completion',
    label: 'Дата работ (план)',
    render: (val) => (val ? dayjs(val).format('DD.MM.YYYY') : <Value data={val} />),
  },
  {
    key: 'address',
    label: 'Адрес',
    render: (val) => <Value data={val} />,
  },
  {
    key: 'responsible_name',
    label: 'Ответственный за работу',
    render: val => <Value data={Array.isArray(val) ? val.filter(Boolean).join(', ') : val} />,
  },
  {
    key: 'engineers_name',
    label: 'Инженеры',
    render: val => <Value data={Array.isArray(val) ? val.filter(Boolean).join(', ') : val} />,
  },
  {
    key: 'phone',
    label: 'Телефон',
  },
]


